// extracted by mini-css-extract-plugin
export default {"wrap":"logo_wrap__JtGfC","center":"logo_center__q1n7G"};